import { __assign } from "tslib";
import { pathOr, pickBy, values } from 'shared/utils';
/**
 * Find Start and End Point of an element timeline
 */
export var findStartEndPoint = function (timeline) {
    // @ts-ignore
    var childrenTimelines = timeline.children;
    var processChildTimeline = function (acc, tl) {
        var _a;
        var elementId = pathOr('', ['animatables', 0, 'target', 'id'], tl);
        var prevStart = pathOr(1000000, [elementId, 'start'], acc);
        var prevEnd = pathOr(0, [elementId, 'end'], acc);
        var prevHideUntilStart = pathOr(false, [elementId, 'hideUntilStart'], acc);
        var prevHideAfterEnd = pathOr(false, [elementId, 'hideAfterEnd'], acc);
        return __assign(__assign({}, acc), (_a = {}, _a[elementId] = {
            selector: "#" + elementId,
            start: Math.min(tl.offset, prevStart),
            end: Math.max(tl.duration, prevEnd),
            hideUntilStart: prevHideUntilStart === true
                ? prevHideUntilStart
                : hasVisibilityPoint(tl.animations).hideUntilStart,
            hideAfterEnd: prevHideAfterEnd === true
                ? prevHideAfterEnd
                : hasVisibilityPoint(tl.animations).hideAfterEnd,
        }, _a));
    };
    return childrenTimelines.reduce(processChildTimeline, {});
};
/**
 * Find if the animation includes visibility related properties
 * and decides if it should hide before and/or after the animation
 */
export var hasVisibilityPoint = function (animations) {
    var opacityAnimation = animations.find(function (a) { return a.property === 'opacity'; });
    if (!opacityAnimation) {
        return {
            hideUntilStart: false,
            hideAfterEnd: false,
        };
    }
    var fromValue = opacityAnimation.tweens[0].from.original;
    var toValue = opacityAnimation.tweens[0].to.original;
    return {
        hideUntilStart: fromValue === '0',
        hideAfterEnd: toValue === '0',
    };
};
/**
 * Find in time point data which element needs to hide
 */
export var showHideElement = function (timePointData, currentTime) {
    var elementsToHide = collectElementsToHide(timePointData);
    values(elementsToHide).forEach(function (timePoint) {
        var selector = timePoint.selector;
        var elm = document.querySelector(selector);
        // Occasionally, this function is fired after the dom is unmounted.
        // This check is to avoid unnecessary errors that result from that.
        if (!elm) {
            return;
        }
        elm.style.visibility = getElementVisibilityOnTimeline(timePoint, currentTime);
    });
};
export var getElementVisibilityOnTimeline = function (timePoint, currentTime) {
    var hideUntilStart = timePoint.hideUntilStart, hideAfterEnd = timePoint.hideAfterEnd, start = timePoint.start, end = timePoint.end;
    var visibility = 'visible';
    // both end is hidden
    if (hideUntilStart && hideAfterEnd) {
        var isOutside = currentTime < start || currentTime > end;
        return isOutside ? 'hidden' : visibility;
    }
    // only hide until start
    if (hideUntilStart) {
        return currentTime < start ? 'hidden' : visibility;
    }
    // only hide after end
    if (hideAfterEnd) {
        return currentTime > end ? 'hidden' : visibility;
    }
    return visibility;
};
/**
 * Collects elements needs to hide
 */
export var collectElementsToHide = function (timePointData) {
    var needToHide = function (timePoint) {
        return timePoint.hideAfterEnd || timePoint.hideUntilStart;
    };
    return pickBy(needToHide, timePointData);
};
